__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "sdk-structure-app";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@material-ui/core", "4.11.4", function() { return Promise.all([__webpack_require__.e(777), __webpack_require__.e(778), __webpack_require__.e(38), __webpack_require__.e(362), __webpack_require__.e(735)]).then(function() { return function() { return __webpack_require__(5778); }; }); });
			register("chart.js", "2.9.3", function() { return __webpack_require__.e(594).then(function() { return function() { return __webpack_require__(6594); }; }); });
			register("clsx", "1.1.0", function() { return __webpack_require__.e(182).then(function() { return function() { return __webpack_require__(8182); }; }); });
			register("history", "4.10.1", function() { return __webpack_require__.e(800).then(function() { return function() { return __webpack_require__(2610); }; }); });
			register("react-chartjs-2", "2.9.0", function() { return Promise.all([__webpack_require__.e(353), __webpack_require__.e(38), __webpack_require__.e(725)]).then(function() { return function() { return __webpack_require__(8353); }; }); });
			register("react-dom", "16.13.1", function() { return Promise.all([__webpack_require__.e(164), __webpack_require__.e(38)]).then(function() { return function() { return __webpack_require__(4164); }; }); });
			register("react-helmet", "6.1.0", function() { return Promise.all([__webpack_require__.e(270), __webpack_require__.e(38)]).then(function() { return function() { return __webpack_require__(4270); }; }); });
			register("react-router-dom", "5.1.2", function() { return Promise.all([__webpack_require__.e(165), __webpack_require__.e(38), __webpack_require__.e(951), __webpack_require__.e(894)]).then(function() { return function() { return __webpack_require__(5165); }; }); });
			register("react", "16.13.1", function() { return __webpack_require__.e(791).then(function() { return function() { return __webpack_require__(2791); }; }); });
			register("reactstrap", "7.1.0", function() { return Promise.all([__webpack_require__.e(631), __webpack_require__.e(38), __webpack_require__.e(362), __webpack_require__.e(96)]).then(function() { return function() { return __webpack_require__(6631); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};